import { ReactElement } from 'react';

import {
  Button,
  ChevronDown,
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
  Feedback,
  Icon,
} from '@mesh.ai/rabbit';

type FeedbackActionsProps = {
  options: {
    onClick: () => void;
    label: string;
    icon?: ReactElement<typeof Icon>;
  }[];
  label: string;
};

const FeedbackActions = ({ options, label }: FeedbackActionsProps) => (
  <Dropdown>
    <DropdownTrigger asChild>
      <Button iconLeft={Feedback} variant="outline" iconRight={ChevronDown}>
        {label}
      </Button>
    </DropdownTrigger>
    <DropdownContent style={{ width: '200px' }} align="end">
      {options.map((item) => (
        <DropdownItem onClick={item.onClick} style={{ display: 'flex', alignItems: 'center' }}>
          {item.icon}
          <span>{item.label}</span>
        </DropdownItem>
      ))}
    </DropdownContent>
  </Dropdown>
);

export default FeedbackActions;
